import React from 'react';
import ReactDOM from 'react-dom';
import App from './App';
import './styles.css';
import { initMsal } from './auth/msalInstance';

// redirectUri is our own origin, so Azure AD redirects the MSAL login popup back
// to this same bundle. Mounting the app in that popup would let LoginScreen call
// loginPopup a second time, which MSAL rejects with block_nested_popups. MSAL
// names its popups "msal.<clientId>...", so detect that (same check MSAL itself
// uses internally) and skip mounting — the opener window's PopupClient already
// polls the popup's URL and closes it once the auth response is captured.
const isMsalPopup = !!window.opener && window.opener !== window &&
  typeof window.name === 'string' && window.name.indexOf('msal.') === 0;

if (!isMsalPopup) {
  // Settle MSAL's redirect handling before anything can start a login.
  initMsal().then(() => {
    ReactDOM.render(
      <React.StrictMode>
        <App />
      </React.StrictMode>,
      document.getElementById('root')
    );
  });
}
